/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SearchEffort = {
  Low: "low",
  Medium: "medium",
  High: "high",
} as const;
export type SearchEffort = ClosedEnum<typeof SearchEffort>;

/** @internal */
export const SearchEffort$inboundSchema: z.ZodNativeEnum<typeof SearchEffort> =
  z.nativeEnum(SearchEffort);
/** @internal */
export const SearchEffort$outboundSchema: z.ZodNativeEnum<typeof SearchEffort> =
  SearchEffort$inboundSchema;
